import { useQuery } from '@tanstack/react-query';
import { getCRUDList } from '../services/crudService';
import shouldKeepPreviousData from '../utils/shouldKeepPreviousData';

const getSeviceTickets = async params => {
  const { data } = await getCRUDList({ entity: 'ticket', params });
  return data || [];
};

export const useServiceTickets = params => {
  return useQuery({
    queryKey: ['serviceTickets', JSON.stringify(params)],
    queryFn: () => getSeviceTickets(params),
    placeholderData: [],
    staleTime: 0,
    // refetchInterval: 1000 * 60 * 1, // 1 minute,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    keepPreviousData: shouldKeepPreviousData(params),
  });
};
